import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

// Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 根据 i18n 语言设置 Element Plus 语言
const elLocale = i18n.global.locale.value === 'zh-CN' ? zhCn : en

app.use(store)
   .use(router)
   .use(i18n)
   .use(ElementPlus, { locale: elLocale })
   .mount('#app')
